const actions = {
  LOAD_REVIEWS: 'LOAD_REVIEWS',
  SUCCESS_REVIEWS: 'SUCCESS_REVIEWS',
  ERROR: 'ERROR',
  ADD_REVIEWS: 'ADD_REVIEWS',
  REVIEWS_OVER: 'REVIEWS_OVER',
  USER_PARAM_CHANGE: 'USER_PARAM_CHANGE',
  ALLREVIEWS_LIKE_REVIEW: 'ALLREVIEWS_LIKE_REVIEW',
};
export default actions;
